import { User01 } from '@untitled-ui/icons-react';
import React from 'react';
import { twMerge } from 'tailwind-merge';

type AvatarProps = React.HTMLAttributes<HTMLDivElement> & {
  initials?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  color?: 'accent' | 'green' | 'yellow' | 'red' | 'neutral' | 'gray' | 'orange' | 'accent-contrast';
  className?: string;
  icon?: React.ReactNode;
};

const sizeClasses = {
  xs: 'size-5 font-body-3-m',
  sm: 'w-6 h-6 font-body-3-m',
  md: 'w-8 h-8 font-body-2-m',
  lg: 'w-10 h-10 font-body-1-m',
};

const colorClasses = {
  accent: 'bg-branding-accent-50 text-branding-accent',
  green: 'bg-green-50 text-green-600',
  yellow: 'bg-yellow-50 text-yellow-600',
  red: 'bg-red-50 text-red-600',
  neutral: 'bg-neutral-50 text-neutral-600',
  gray: 'bg-branding-gray-50 text-branding-gray-600',
  orange: 'bg-orange-100 text-orange-400',
  'accent-contrast': 'bg-branding-accent text-white',
};

export const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>(function Avatar(props, ref) {
  const { initials, size = 'lg', color = 'accent', className, icon, ...rest } = props;
  const contentClassName = twMerge([
    'rounded-full flex items-center justify-center font-body flex-shrink-0',
    sizeClasses[size],
    colorClasses[color],
    className,
  ]);
  return (
    <div ref={ref} className={contentClassName} {...rest}>
      {initials != null ? <span>{initials}</span> : null}
      {icon != null ? icon : null}
      {initials == null && icon == null ? <User01 /> : null}
    </div>
  );
});
